import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=5752581c&scoped=true&"
var script = {}
import style0 from "./Section.vue?vue&type=style&index=0&id=5752581c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752581c",
  null
  
)

export default component.exports